import React from 'react';


export const Ansible = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/ansible.png')} />
    )
};
